import { jsx as _jsx } from "react/jsx-runtime";
const IconCaret = () => {
    return (_jsx("svg", { "aria-hidden": "true", focusable: "false", className: "icon icon-caret", viewBox: "0 0 10 6", children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z", fill: "currentColor" }) }));
};
export default IconCaret;
